import { useQueryClient } from "@tanstack/react-query";
import { Navigate } from "react-router-dom";

import AuthenticationLayout from "~/common/components/layouts/AuthenticationLayout";
import { PhoneVerification } from "~/common/components/PhoneVerification";
import { isUserVerified } from "~/common/utils";
import { patientWelcomeText } from "~/patients/constants/constants";
import { useUpdatePhoneNumber } from "~/patients/hooks/useUpdatePhoneNumber";
import {
  useCancelVerificationCode,
  useGetCurrentPatient,
  useLogoutPatient,
  useRetryVerificationCode,
  useSendVerificationCode,
  useVerifyCode,
} from "../hooks";
import { ROUTES } from "../router";

export const VerifyPhone = () => {
  const queryClient = useQueryClient();

  const { data: patient } = useGetCurrentPatient();
  const { logoutMutation } = useLogoutPatient();
  const { mutate: cancel, isPending: isCancelling } =
    useCancelVerificationCode();
  const { mutate: retry, isPending: isRetrying } = useRetryVerificationCode();
  const { mutate: send, isPending: isSending } = useSendVerificationCode();
  const { mutate: update, isPending: isUpdating } = useUpdatePhoneNumber();
  const { mutate: verify, isPending: isVerifying } = useVerifyCode();

  const isLoading =
    isCancelling || isRetrying || isSending || isUpdating || isVerifying;

  if (!patient) return null;
  if (isUserVerified(patient)) return <Navigate to={ROUTES.home} />;

  return (
    <AuthenticationLayout
      welcomeText={patientWelcomeText}
      className="justify-between overflow-y-auto md:pb-8"
    >
      <div className="flex h-full w-full items-center justify-center">
        <PhoneVerification
          actions={{
            cancel,
            send,
            retry,
            update,
            verify,
          }}
          isLoading={isLoading}
          onCancel={logoutMutation}
          onSuccess={() =>
            queryClient.invalidateQueries({
              queryKey: ["getCurrentPatient"],
            })
          }
          userId={patient.id}
        />
      </div>
    </AuthenticationLayout>
  );
};
